<template>
	<v-tabs 
		v-model="tab"
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Stati" ripple class="secondary-tab">
			Stati
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Campi">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="project"></fields-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Stati">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title="Stati progetto"
						action-icon='settings'
						model-def='generaltypes-project_status'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Azioni">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="project"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Altro">
			<v-row class="ma-0">
				<projects-options></projects-options>
			</v-row>
		</v-tab-item>
	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import ProjectsOptions from '@/components/modules/projects/settings/ProjectsOptions'

	export default {
		name:'orders-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            ProjectsOptions
        },		
		data() {
			return {
				// ?tab=altro apre la scheda Altro (card Causali commessa), usato dal link della scheda Commessa
				tab: this.$route.query.tab === 'altro' ? 3 : 0,
			}
		},
	}
  </script>
